import { FieldType } from 'types/graphql'

const checkValues = (target: any, fieldType: FieldType) => {
  return target.some(item => {
    if (Array.isArray(item)) {
      if (item.length === 0) {
        return false
      }

      return checkValues(item, fieldType)
    } else {
      if (fieldType === FieldType.PickList || fieldType === FieldType.Lookup) {
        return !item.value?.value
      }

      return !item.value
    }
  })
}

export const checkIsFieldValueExist = (formValues: any, id: string, fieldType: FieldType) => {
  const target = formValues[id]

  if (Array.isArray(target)) {
    return checkValues(target, fieldType)
  }

  if (target) {
    let res = false

    for (const key in target) {
      const result = checkIsFieldValueExist(target, key, fieldType)

      if (result) {
        res = true
      }
    }

    return res
  }

  return true
}
